const colors = {
  coral200: "#FED5C0",
  coral100: "#FEECDF",
  coral300: "#FCB99F",
  coral400: "#FA9D87",
  coral500: "#F77160",
  coral600: "#D44A46",
  coral700: "#B13036",
  coral800: "#8F1E2D",
  coral900: "#761227",
  blue100: "#D2DCF6",
  blue200: "#A7BAEE",
  blue300: "#7188CD",
  blue400: "#44589C",
  blue500: "#17255A",
  blue600: "#101C4D",
  blue700: "#0B1440",
  blue800: "#070D34",
  blue900: "#04092B",
  grey100: "#F4F7F7",
  grey200: "#EAEFF0",
  grey300: "#CBD1D2",
  grey400: "#9FA4A6",
  grey500: "#65696B",
  grey600: "#49545C",
  grey700: "#32404D",
  grey800: "#202E3E",
  grey900: "#132033",
  green100: "#D8F9D5",
  green200: "#ADF3AD",
  green300: "#7CDB85",
  green400: "#54B767",
  green500: "#268742",
  green600: "#1B743D",
  green700: "#136138",
  green800: "#0C4E32",
  green900: "#07402E",
  red100: "#FCE5D9",
  red200: "#FAC6B4",
  red300: "#F29D8B",
  red400: "#E5766C",
  red500: "#D53F3F",
  red600: "#B72E39",
  red700: "#991F34",
  red800: "#7B142E",
  red900: "#660C2B",
  streamRed100: "#FFEAE9",
  streamRed200: "#FFA29E",
  streamRed300: "#FF7F78",
  streamRed400: "#ED5454",
  streamRed500: "#D53F3F",
  streamRed600: "#B72E39",
  streamRed700: "#991F34",
  streamRed800: "#7B142E",
  streamRed900: "#660C2B",
  yellow100: "#FFFACC",
  yellow500: "#FFE91F",
  yellow900: "#FFCC15",
  teal100: "#E2FAF7",
  teal200: "#C2F9EA",
  teal300: "#9FECDF",
  teal400: "#81DBD3",
  teal500: "#59C3C3",
  teal600: "#419EA7",
  teal700: "#2C7B8C",
  teal800: "#1C5B71",
  teal900: "#11435D",
  streamBlue100: "#EBF6FF",
  streamBlue200: "#B7DCFF",
  streamBlue300: "#61B3FF",
  streamBlue400: "#2897FF",
  streamBlue500: "#0070D9",
  streamBlue600: "#0062BE",
  streamBlue700: "#005AAE",
  streamBlue800: "#004688",
  streamBlue900: "#00386D",
  mono900: "#14171A",
  mono500: "#353F44",
  mono100: "#65696B",
  white500: "#EFEFEF",
  pure: {
    white: "#FFFFFF",
    black: "#000000",
  },
};

export default colors;
